import { render, staticRenderFns } from "./edit-closure.vue?vue&type=template&id=237f9864&"
import script from "./edit-closure.vue?vue&type=script&lang=ts&"
export * from "./edit-closure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-closure.vue"
export default component.exports